import React, { useEffect, useState } from "react";
import axios from "axios";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom"; 

const AddTyre = () => {
  useAuthRedirect();
  const navigate = useNavigate(); // Initialize navigate function
  const [suppliers, setsuppliers] = useState([]);
  const [formData, setFormData] = useState({
    battery_make: "",
    battery_type: "",
    battery_code: "",
    purchase_from: "",
    life_y: "",
    life_m: ""
  });

     const canEntry = hasPermission("Battery Card", "entry");

  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/get_supplier")
      .then((response) => {
        setsuppliers(response.data.suppliers);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    console.log("Form Submit Triggered");
    console.log("Form Data:", formData);
  
    // Step 1: Define  fields
    const Fields = [
      { key: "battery_make", label: "Battery Make" },
      { key: "battery_type", label: "Battery Type" },
      { key: "life_y", label: "Year" },
      { key: "life_m", label: "Month" },
      { key: "purchase_from", label: "From Purchasing" },
      { key: "battery_code", label: "Battery Code" },
      
    ];
  
    // Step 2: Validation Loop
    for (const field of Fields) {
      const value = formData[field.key];
      if (!value || value.toString().trim() === "") {
        await Swal.fire({
          icon: "warning",
          title: "Missing Field",
          text: `Please enter ${field.label}`,
          width: "400px"
        });
        return; // Stop submission if validation fails
      }
    }
  
    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      const payload = {
        battery_make: formData.battery_make,
        battery_type: formData.battery_type,
        life_y: formData.life_y,
        life_m: formData.life_m,
        purchase_from: formData.purchase_from,
        battery_code: formData.battery_code,
      };
  
      console.log("Payload being sent to server:", payload);
  
      const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/add_battery_card_api`, payload);
  
      console.log("Server response:", response.data);
  
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Inserted!",
          text: "Battery inserted successfully.",
        });
        navigate("/battery_card_listing");
      } else {
        Swal.fire({
          icon: "error",
          title: "Insert Failed",
          text: response.data.message || "Unknown error.",
        });
      }
  
    } catch (error) {
  console.error("Error inserting battery:", error);

  if (error.response && error.response.data && error.response.data.message) {
    Swal.fire({
      icon: "error",
      title: "Insert Failed",
      text: error.response.data.message,  // <-- will show "This Battery Code already exists."
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Insert failed. Please try again.",
    });
  }
}

  };
  
if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
                    <h2 className="add-txt">Add New Battery Card</h2>
                    <Link to='/battery_card_listing'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>

          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Battery Code:</label>
                <input
                  type="text"
                  name="battery_code"
                  value={formData.battery_code}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Battery Make:</label>
                <input
                  type="text"
                  name="battery_make"
                  value={formData.battery_make}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Battery Type:</label>
                <input
                  type="text"
                  name="battery_type"
                  value={formData.battery_type}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Purchased from:</label>
                <select  name="purchase_from" value={formData.purchase_from}   className="branch-select"   onChange={handleChange}>
                    <option value="">-Select Supplier-</option>
                    {suppliers.map((item) => (
                        <option key={item.supplierMaster_code} value={item.supplierMaster_code}>
                        {item.supplierMaster_name}
                        </option>
          ))}
        </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Expected Life (years):</label>
                <select  name="life_y" value={formData.life_y}   className="branch-select"  onChange={handleChange} >
                <option value="">--- Select ---</option>
                <option value="0 year">0 year</option>
                <option value="1 year">1 year</option>
                <option value="2 years">2 years</option>
                <option value="3 years">3 years</option>
                <option value="4 years">4 years</option>
                <option value="5 years">5 years</option>
                <option value="6 years">6 years</option>
                <option value="7 years">7 years</option>
                <option value="8 years">8 years</option>
                <option value="9 years">9 years</option>
            </select>
              </div>
              <div className="form-group">
                <label>Expected Life (Months) :</label>
                <select name="life_m"  value={formData.life_m}   className="branch-select"  onChange={handleChange} >
                    <option value="">--- Select ---</option>
                    <option value="0 month">0 month</option>
                    <option value="1 month">1 month</option>
                    <option value="2 months">2 months</option>
                    <option value="3 months">3 months</option>
                    <option value="4 months">4 months</option>
                    <option value="5 months">5 months</option>
                    <option value="6 months">6 months</option>
                    <option value="7 months">7 months</option>
                    <option value="8 months">8 months</option>
                    <option value="9 months">9 months</option>
                    <option value="10 months">10 months</option>
                    <option value="11 months">11 months</option>
                </select>
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default AddTyre;
